function getCurrentSchoolYearStart() {
  const now = new Date();
  const year = now.getFullYear();
  return now.getMonth() >= 5 ? year : year - 1; // school year starts June
}

export function getSchoolYearOptions(rangeBack = 2, rangeForward = 1) {
  const start = getCurrentSchoolYearStart();
  const years = [];
  for (let y = start + rangeForward; y >= start - rangeBack; y--) {
    years.push(`${y}-${y + 1}`);
  }
  return years;
}

export const CURRENT_SCHOOL_YEAR = `${getCurrentSchoolYearStart()}-${getCurrentSchoolYearStart() + 1}`;

// Derives the school year (e.g. "2025-2026") from a 'YYYY-MM-DD' date string, for
// records that don't store their own school_year but do have a date field.
export function getSchoolYearForDate(dateString) {
  const match = /^(\d{4})-(\d{2})/.exec(String(dateString ?? ''));
  if (!match) return '';
  const year = Number(match[1]);
  const month = Number(match[2]);
  const start = month >= 6 ? year : year - 1;
  return `${start}-${start + 1}`;
}
